import { Component, ChangeDetectionStrategy } from '@angular/core';

import { IconsModule } from '../../shared/core/modules/icons.module';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrl: './welcome-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconsModule],
})
export class WelcomePageComponent {
  currentYear: number = new Date().getFullYear();

}
